<template>
  <div>
    <div id="header" class="header">
      <div class="inner">
        <div class="flexbetween">
          <!-- 左メニュー -->
          <div v-if="(isAu() && !isAuPremiumAppVer) || isSoftbank()" class="navigation menu-bar" />
          <div v-else class="navigation menu-bar">
            <popover name="navigation-left" :closeOnContentClick="true">
              <div class="btn-menu-bar" slot="face"><img src="static/images/icon/header/logo-s.png"></div>
              <div class="navigation-left-content" slot="content">
                <ul>
                  <li v-if="showDictionary" @click="goDictionary()">辞書</li>
                  <li @click="goLibrary()">ライブラリへ戻る</li>
                </ul>
              </div>
            </popover>
          </div>

          <!--
          <div class="title">
            <div v-if="isDocomo()" class="contentname lbold">ロゼッタストーン日常会話</div>
            <div v-else class="contentname lbold">{{ productInfo.name }}</div>

            <div class="levelunit flexcenter" v-show="!isCurrentViewHome">
              <span class="lvl-sorange font14">レベル{{ levelNo }}</span>
              <div class="unit">ユニット {{ unitNo }} 「{{ unitTitle }}」: レッスン {{ lessonIndex + 1 }} : {{ pathTitle }}</div>
            </div>
          </div>
          -->

          <div v-if="isCurrentViewHome" class="contentname lbold sp-top">{{ contentName }}</div>
          <div v-else-if="isEnvironmentPc()" class="contentname lbold">{{ contentName }} : レッスン {{ lessonIndex + 1 }} {{ pathTitle }}</div>
          <div v-else class="contentname lbold">{{ contentName }}<br>レッスン {{ lessonIndex + 1 }} {{ pathTitle }}</div>

          <div class="sp-second-header" v-show="!isCurrentViewHome">
            <div class="items flexcenter">
              <div class="progress font18">
                <div v-if="isMilestone"><span class="textred">{{ milestoneGroupIndex }}</span> / {{ milestoneGroupLength }}</div>
                <div v-else><span class="textred">{{ pathstepIndex + 1 }}</span> / {{ pathstepLength }}</div>
              </div>

              <!-- setting buttons -->
              <div class="flexbox">
                <!-- 表示モード切替ボタン -->
                <div class="setting-lang" v-show="showDisplayMode">
                  <!-- 中国語：簡体字 -->
                  <popover name="answer" :closeOnContentClick="true" v-if="productInfo.language == constants.LANGUAGE_CODE_ZHCV && isScriptTypeKan">
                    <div slot="face">
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_WITH_PINYIN">
                        <img src="/static/images/icon/header/han-and-pinin.png"/>
                      </div>
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_NO_PINYIN">
                        <img src="/static/images/icon/header/han.png"/>
                      </div>
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_PINYIN_ONLY">
                        <img src="/static/images/icon/header/han-pinin.png"/>
                      </div>
                    </div>
                    <div class="lang-status" slot="content">
                      <ul>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_WITH_PINYIN)" :class='{ active: displayMode == constants.DISPLAY_MODE_WITH_PINYIN }'>
                          簡体字（ピンイン付き）
                        </li>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_NO_PINYIN)" :class='{ active: displayMode == constants.DISPLAY_MODE_NO_PINYIN }'>
                          簡体字のみ
                        </li>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_PINYIN_ONLY)" :class='{ active: displayMode == constants.DISPLAY_MODE_PINYIN_ONLY }'>
                          ピンインのみ
                        </li>
                      </ul>
                    </div>
                  </popover>
                  <!-- 中国語：繁体字 -->
                  <popover name="answer" :closeOnContentClick="true" v-if="productInfo.language == constants.LANGUAGE_CODE_ZHCV && isScriptTypeHan">
                    <div slot="face">
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_WITH_PINYIN">
                        <img src="/static/images/icon/header/kan-and-pinin.png"/>
                      </div>
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_NO_PINYIN">
                        <img src="/static/images/icon/header/kan.png"/>
                      </div>
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_PINYIN_ONLY">
                        <img src="/static/images/icon/header/kan-pinin.png"/>
                      </div>
                    </div>
                    <div class="lang-status" slot="content">
                      <ul>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_WITH_PINYIN)" :class='{ active: displayMode == constants.DISPLAY_MODE_WITH_PINYIN }'>
                          繁体字（ピンイン付き）
                        </li>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_NO_PINYIN)" :class='{ active: displayMode == constants.DISPLAY_MODE_NO_PINYIN }'>
                          繁体字のみ
                        </li>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_PINYIN_ONLY)" :class='{ active: displayMode == constants.DISPLAY_MODE_PINYIN_ONLY }'>
                          ピンインのみ
                        </li>
                      </ul>
                    </div>
                  </popover>
                  <!-- ヘブライ語 -->
                  <popover name="answer" :closeOnContentClick="true" v-if="productInfo.language == constants.LANGUAGE_CODE_HEIL">
                    <div slot="face">
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_UNVOWELED">
                        <img src="/static/images/icon/header/he-nosign.png"/>
                      </div>
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_VOWELED">
                        <img src="/static/images/icon/header/he-sign.png"/>
                      </div>
                    </div>
                    <div class="lang-status" slot="content">
                      <ul>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_UNVOWELED)" :class='{ active: displayMode == constants.DISPLAY_MODE_UNVOWELED }'>
                          母音記号なし
                        </li>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_VOWELED)" :class='{ active: displayMode == constants.DISPLAY_MODE_VOWELED }'>
                          母音記号あり
                        </li>
                      </ul>
                    </div>
                  </popover>
                  <!-- 日本語 -->
                  <popover name="answer" :closeOnContentClick="true" v-if="productInfo.language == constants.LANGUAGE_CODE_JAJP">
                    <div slot="face">
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_KANJI_WITH_KANA">
                        <img src="/static/images/icon/header/kan-huri.png"/>
                      </div>
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_KANJI">
                        <img src="/static/images/icon/header/kan-ja.png"/>
                      </div>
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_KANA">
                        <img src="/static/images/icon/header/hira-kata.png"/>
                      </div>
                      <div class="btn-lang" v-show="displayMode == constants.DISPLAY_MODE_ROMAJI">
                        <img src="/static/images/icon/header/roma.png"/>
                      </div>
                    </div>
                    <div class="lang-status" slot="content">
                      <ul>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_KANJI_WITH_KANA)" :class='{ active: displayMode == constants.DISPLAY_MODE_KANJI_WITH_KANA }'>
                          漢字（ふりがな付き）
                        </li>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_KANJI)" :class='{ active: displayMode == constants.DISPLAY_MODE_KANJI }'>
                          漢字
                        </li>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_KANA)" :class='{ active: displayMode == constants.DISPLAY_MODE_KANA }'>
                          ひらがな・カタカナ
                        </li>
                        <li @click="setDisplayMode(constants.DISPLAY_MODE_ROMAJI)" :class='{ active: displayMode == constants.DISPLAY_MODE_ROMAJI }'>
                          ローマ字
                        </li>
                      </ul>
                    </div>
                  </popover>
                </div>
                <!-- 辞書ボタン -->
                <div v-if="showDictionary && !isEnvironmentPc()" @click="goDictionaryWordList()" class="setting-dic">
                  <div class="btn-dic" style="cursor: default"><img src="static/images/icon/header/icon_dic.png" /></div>
                </div>
                <!-- 解答ボタン -->
                <div class="setting-lang" v-show="!isCurrentViewHome">
                  <div v-if="isReview" class="btn-lang" style="cursor: default"><img src="/static/images/icon/header/lang-off.png"/></div>
                  <popover v-else name="answer" :closeOnContentClick="true">
                    <div slot="face">
                      <!-- 全解答 -->
                      <div class="btn-lang" v-if="isAllAnswerVisible"><img src="/static/images/icon/header/lang-en.png"/></div>
                      <!-- デフォルト -->
                      <div class="btn-lang" v-else><img src="/static/images/icon/header/lang-en-t.png"/></div>
                    </div>
                    <div class="lang-status" slot="content">
                      <ul>
                        <li :class='{ active: isAllAnswerVisible }' @click="changeShowAllAnswer()">全解答を表示する</li>
                      </ul>
                    </div>
                  </popover>
                </div>
                <!-- レッスンスコア -->
                <div v-show="!isCurrentViewHome" class="setting-score">
                  <div class="btn-score" style="cursor: default" v-if="isMilestone || isReview">
                    <img src="/static/images/icon/header/score-off.png"/>
                  </div>
                  <div v-else class="btn-score" @click="showLessonScore()">
                    <img src="/static/images/icon/header/score.png"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 右メニュー -->
          <div class="navigation menu-dots">
            <popover name="navigation-right" :closeOnContentClick="true">
              <div class="btn-menu-dots" @click="updateMenu()" slot="face"><img src="static/images/icon/header/setting-dots.png"></div>
              <div class="navigation-right-content" slot="content">
                <ul>
                  <li v-if="!isCurrentViewHome" @click="goHome()">ホームへ戻る</li>
                  <li @click="showSetting()">設定</li>
                  <li v-if="!isDocomo() && isCurrentViewHome"><a @click="pauseAudio()" :href="tourURL" target="_blank" class="readme">ツアーを開始</a></li>
                  <li v-if="isDocomo()" class="docomo_push">
                    <div><span>プッシュ通知を許可</span><span class="push_option" :class="{ active: isPushEnabled }" @click="showPushSetting()">ON</span><span class="push_option" :class="{ active: !isPushEnabled }" @click="showPushSetting()">OFF</span></div>
                    <div class="font14 lbold ml10 mt10">月に1~3回程度アップデート案内します。</div>
                    <div class="font14 ml10"><span>らくらくスマートフォン等の非対応機種では配信されません。</span></div>
                  </li>
                  <li v-if="isAu() || isSoftbank()" class="other_push"><span>プッシュ通知を許可</span><span class="push_option" :class="{ active: isPushEnabled }" @click="showPushSetting()">ON</span><span class="push_option" :class="{ active: !isPushEnabled }" @click="showPushSetting()">OFF</span></li>
                  <li v-if="!isCarrier()"><a @click="pauseAudio()" href="http://www.sourcenext.com/manual_sc/pc/rosettastone_advanced/home/" target="_blank" class="helptext">ヘルプ</a></li>
                  <li v-on:click="clickLanguageLetterButton">学習言語の文字一覧</li>
                  <li v-if="!isCarrier()"><a @click="pauseAudio()" :href="audioCompanionURL" target="_blank" class="readme">Audio Companion</a></li>
                  <li v-if="!isCarrier()"><a @click="pauseAudio()" href="https://www.sourcenext.com/r/p/rosettastone/eula/" target="_blank" class="readme">Rosetta Stone について</a></li>
                  <li v-if="isDocomo()" @click="showPrivacyPolicy()">プライバシーポリシー</li>
                  <li v-if="(isAu() && !isAuPremiumAppVer) || isSoftbank()" @click="showTakeOver()">引継ぎコード発行</li>
                  <li v-if="isSoftbank()"><a @click="pauseAudio()" :href="getTosUrl()" target="_blank">利用規約</a></li>
                  <li v-if="isAu() || isSoftbank()"><a @click="pauseAudio()" :href="getContactUrl()" target="_blank">お問い合わせ</a></li>
                  <li v-if="isAu() || isSoftbank()"><a @click="pauseAudio()" :href="getFaqUrl()" target="_blank">FAQ</a></li>
                  <li v-if="isSoftbank()" @click="showPrivacyPolicy()">プライバシーポリシー</li>
                  <li v-if="isAu()"><a @click="pauseAudio()" href="http://www.sourcenext.com/r/p/au/rosetta_us/product/" target="_blank">製品紹介</a></li>
                </ul>
                <!-- <div class="hintArea" v-if="note.length != 0">
                  <div class="hint"><img src="../../static/images/icon/header/hint.png"/>ヒント</div>
                  <div>{{ note }}</div>
                </div> -->
                <div class="hintArea" v-if="showHintArea">
                  <div>{{ hintText }}</div>
                </div>
              </div>
            </popover>
          </div>
        </div>
      </div>
    </div>

    <!-- ログアウト画面 -->
    <Logout v-if="isLogoutVisible" @closeLogout="closeLogout()" :productInfo="productInfo" />

    <!-- 引継ぎコード発行画面 -->
    <TakeOver v-if="isTakeOverVisible" @close="closeTakeOver()" />

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popover from "vue-popover";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";
import common from "@/mixin/common";
import Logout from "@/components/Logout";
import TakeOver from "@/components/TakeOver";
import http from "@/mixin/http";

const VIEW_NAME_RUNMODE = "Runmode";
const VIEW_NAME_HOME = "Home";

const APNAME_US = "rosetta_us";
const APNAME_CN = "rosetta_cn";
const APNAME_KR = "rosetta_kr";

const URL_BIND_STRING_APNAME = "{APNAME}";
const URL_BIND_STRING_VERSION = "{VERSION}";

const URL_TOS_SOFTBANK = "http://www.sourcenext.com/r/p/softbank/" + URL_BIND_STRING_APNAME + "/eula/";

const URL_CONTACT_AU = "https://www.sourcenext.com/faq/cgi-bin/Inquiry002_J.cgi?type=%a5%ed%a5%bc%a5%c3%a5%bf%a5%b9%a5%c8%a1%bc%a5%f3%b1%d1%b8%ec&ver=" + URL_BIND_STRING_VERSION + "au";
const URL_CONTACT_SOFTBANK_US = "https://www.sourcenext.com/faq/cgi-bin/Inquiry002_J.cgi?type=%a5%ed%a5%bc%a5%c3%a5%bf%a5%b9%a5%c8%a1%bc%a5%f3%b1%d1%b8%ec&ver=" + URL_BIND_STRING_VERSION + "sb";
const URL_CONTACT_SOFTBANK_CN = "https://www.sourcenext.com/faq/cgi-bin/Inquiry002_J.cgi?type=%a5%ed%a5%bc%a5%c3%a5%bf%a5%b9%a5%c8%a1%bc%a5%f3%c3%e6%b9%f1%b8%ec&ver=" + URL_BIND_STRING_VERSION + "sb";
const URL_CONTACT_SOFTBANK_KR = "https://www.sourcenext.com/faq/cgi-bin/Inquiry002_J.cgi?type=%a5%ed%a5%bc%a5%c3%a5%bf%a5%b9%a5%c8%a1%bc%a5%f3%b4%da%b9%f1%b8%ec&ver=" + URL_BIND_STRING_VERSION + "sb";

const URL_FAQ_AU = "http://www.sourcenext.com/r/p/au/rosetta_us/support/";
const URL_FAQ_SOFTBANK = "http://www.sourcenext.com/r/p/softbank/" + URL_BIND_STRING_APNAME + "/support/";

export default {
  name: "toolbar",
  props: {
    currentView: String,
    jsonData: Object,
    productInfo: Object
  },
  data() {
    return {
      isCurrentViewHome: true,
      // 「全解答を表示する」選択状態フラグ
      isAllAnswerVisible: false,
      unitTitle: "",
      pathTitle: "",
      pathstepLength: 0,
      note: "",
      // ログアウト画面表示
      isLogoutVisible: false,
      // プッシュ通知許可状態
      isPushEnabled: false,
      // マイルストーンを出題中はtrue
      isMilestone: false,
      // 復習を出題中はtrue
      isReview: false,
      // 引継ぎコード発行画面表示
      isTakeOverVisible: false,
      audioCompanionURL: "",
      tourURL: "",
      showHintArea: false,
      hintText: "",
      // ポップアップ辞書機能クローズのためツールバーの辞書機能は言語によらず表示しない
      showDictionary: false,
      // au版Androidアプリでプレミアム会員対応版かの判定値
      isAuPremiumAppVer: false
    };
  },
  components: {
    popover,
    Logout,
    TakeOver
  },
  mixins: [
    common,
    http
  ],
  computed: {
    ...mapGetters([
      "levelNo",
      "unitNo",
      "lessonIndex",
      "pathIndex",
      "pathstepIndex",
      "milestoneGroupIndex",
      "milestoneGroupLength",
      "sreUse",
      "showAllAnswer",
      "showDisplayMode"
    ]),
    /**
     * 複数字体
     */
    scriptType: function() {
      return this.$store.getters.scriptType;
    },
    /**
     * 表示形式
     */
    displayMode: function() {
      return this.$store.getters.displayMode;
    },
    /**
     * 中国語字体：簡体字
     */
    isScriptTypeKan: function() {
      return this.scriptType == constants.SCRIPT_TYPE_SETTING_KAN;
    },
    /**
     * 中国語字体：繁体字
     */
    isScriptTypeHan: function() {
      return this.scriptType == constants.SCRIPT_TYPE_SETTING_HAN;
    },
    /**
     * Runmodeヒント文言
     */
    modeGroup: function() {
      return this.$store.getters.modeGroup;
    },
    /**
     * 定数
     */
    constants: function() {
      return constants;
    },
    /**
     * コンテンツ名
     */
    contentName: function() {
      var title = "";
      if (this.isAu()) {
        title = "ロゼッタストーン 英語";
      } else {
        title = this.productInfo.name;
      }
      return title;
    }
  },
  methods: {
    /**
     * ホームへ
     */
    goHome: function() {
      this.log("Toolbar start goHome");

      if (!this.isCurrentViewHome) {
        this.$emit("transitionHome");
      }
    },
    /**
     * 全解答表示状態変更
     */
    changeShowAllAnswer: function() {
      this.log("Toolbar start changeShowAllAnswer");

      // マイルストーンでスライド中は何もしない
      for (var rootChild of this.$parent.$children) {
        if (rootChild.$options.name == "runmode") {
          for (var child of rootChild.$children) {
            if (child.$options.name == "Milestone") {
              if (child.isSwiperAnimating) {
                return;
              }
              break;
            }
          }
        }
      }

      this.isAllAnswerVisible = !this.isAllAnswerVisible;

      // 全解答表示の値を更新
      this.$store.dispatch("setShowAllAnswer", this.isAllAnswerVisible);
    },
    /**
     * レッスンスコア画面を表示
     */
    showLessonScore: function() {
      this.log("Toolbar start showLessonScore");

      this.pauseAudio();
      this.$emit("showLessonScore");
    },
    /**
     * プッシュ通知設定ダイアログを表示
     */
    showPushSetting: function() {
      this.log("Toolbar start showPushSetting");

      // 再生中の音声を停止する。
      this.pauseAudio();

      // 通知設定ダイアログの表示
      window.Phone.ShowPushSetting();
    },
    /**
     * プライバシーポリシー画面を表示
     */
    showPrivacyPolicy: function() {
      this.log("Toolbar start showPrivacyPolicy");

      // 再生中の音声を停止する。
      this.pauseAudio();

      // プライバシーポリシー画面の表示
      window.Phone.ShowPrivacyPolicy();
    },
    /**
     * ログアウト画面を表示
     */
    showLogout: function() {
      this.log("Toolbar start showLogout");

      // 再生中の音声を停止する。
      this.pauseAudio();

      // ログアウト確認画面表示
      this.isLogoutVisible = true;
    },
    /**
     * ログアウト画面を閉じる
     */
    closeLogout: function() {
      this.log("Toolbar start closeLogout");

      this.isLogoutVisible = false;

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * 設定画面を表示
     */
    showSetting: function() {
      this.log("Toolbar start showSetting");

      this.pauseAudio();
      this.$emit("showSetting");
    },
    /**
     * 音声停止処理
     */
    pauseAudio: function() {
      this.log("Toolbar start pauseAudio");

      if (!this.isCurrentViewHome) {
        // state更新
        this.log("set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);

        this.$emit("audioPause");
      }
    },
    /**
     * runmode用のdataを設定
     */
    setDataForRunmode: function() {
      this.isAllAnswerVisible = this.$store.getters.showAllAnswer;

      // unitタイトル
      this.unitTitle = this.$store.getters.currentUnit.title;

      // pathタイトル
      var currentPath = this.$store.getters.currentPath;
      this.pathTitle = currentPath.title;

      // 復習の場合
      if (this.pathTitle === constants.PATH_TITLE_REVIEW) {
        this.isReview = true;
      } else {
        this.isReview = false;
      }

      // マイルストーンの場合
      if (this.pathTitle === constants.PATH_TITLE_MILESTONE) {
        this.isMilestone = true;
      } else {
        this.isMilestone = false;
        // pathstep数
        var currentPathstepsLength = currentPath.pathsteps.length;
        if (0 < currentPathstepsLength) {
          this.pathstepLength = currentPathstepsLength;
        }
      }

      // note
      this.setNote(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex);
    },
    /**
     * noteを設定
     */
    setNote: function(levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex) {
      this.log("Toolbar start setNote levelNo: " + levelNo + ", unitNo: " + unitNo + ", lessonIndex: " + lessonIndex + ", pathIndex: " + pathIndex + ", pathstepIndex: " + pathstepIndex);

      var levelJson = this.getLevelJson(this.jsonData, levelNo);
      var unitJson = this.getUnitJson(levelJson, unitNo);
      this.note = unitJson.lessons[lessonIndex].paths[pathIndex].pathsteps[pathstepIndex].note;
    },
    /**
     * ライブラリ画面へ遷移する
     */
    goLibrary: function() {
      this.log("Toolbar start goLibrary");
      window.location.replace(process.env.LIBRARY_URL);
    },
    /**
     * メニュー表示時の処理
     */
    updateMenu: function() {
      this.log("Click menu");

      // キャリア版以外の場合、何もしない
      if (!this.isCarrier()) {
        return;
      }

      // プッシュ通知許可状態設定
      this.isPushEnabled = window.Phone.GetPushSetting() == 1;
    },
    /**
     * 引継ぎコード発行画面を表示する
     */
    showTakeOver: function() {
      this.log("Toolbar start showTakeOver");

      this.pauseAudio();
      this.isTakeOverVisible = true;
    },
    /**
     * 引継ぎコード発行画面を閉じる
     */
    closeTakeOver: function() {
      this.log("Toolbar start closeTakeOver");

      this.isTakeOverVisible = false;

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * 利用規約画面のURLを取得する
     *
     * @return {String} 利用規約画面URL
     */
    getTosUrl: function() {
      this.log("Toolbar start getTosUrl");
      var result = URL_TOS_SOFTBANK.replace(URL_BIND_STRING_APNAME, this.getApName());
      this.log("Toolbar getTosUrl result:" + result);
      return result;
    },
    /**
     * お問い合わせ画面のURLを取得する
     *
     * @return {String} お問い合わせ画面URL
     */
    getContactUrl: function() {
      this.log("Toolbar start getContactUrl");

      var versionName = window.Phone.GetVersionName();

      var url = "";
      if (this.isAu()) {
        url = URL_CONTACT_AU;
      }
      if (this.isSoftbank()) {
        var apName = this.getApName();
        switch (apName) {
          case APNAME_US:
            url = URL_CONTACT_SOFTBANK_US;
            break;
          case APNAME_CN:
            url = URL_CONTACT_SOFTBANK_CN;
            break;
          case APNAME_KR:
            url = URL_CONTACT_SOFTBANK_KR;
            break;
          default:
            // Ignore
            break;
        }
      }

      var result = url.replace(URL_BIND_STRING_VERSION, versionName);
      this.log("Toolbar getContactUrl result:" + result);
      return result;
    },
    /**
     * FAQ画面のURLを取得する
     *
     * @return {String} FAQ画面URL
     */
    getFaqUrl: function() {
      this.log("Toolbar start getFaqUrl");

      var result = "";

      if (this.isAu()) {
        result = URL_FAQ_AU;
      }

      if (this.isSoftbank()) {
        var apName = this.getApName();
        result = URL_FAQ_SOFTBANK.replace(URL_BIND_STRING_APNAME, apName);
      }

      this.log("Toolbar getFaqUrl result:" + result);
      return result;
    },
    /**
     * 学習言語の文字一覧表示
     */
    clickLanguageLetterButton: function() {
      this.log("Toolbar start LanguageLetter");

      this.pauseAudio();
      this.$emit("showLanguageLetter");
    },
    /**
     * 表示モード設定
     *
     * @param {String} displayMode
     */
    setDisplayMode: function(displayMode) {
      var self = this;
      // ストアに保存
      this.$store.dispatch("setDisplayMode", displayMode);
      this.$store.dispatch("setTrueDisplayMode", displayMode);

      // key-value設定
      var result = { data: [] };
      result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_DISPLAYMODE, this.displayMode));
      this.doSetKeyValue(JSON.stringify(result)).then(function() {
      }).catch(function(message) {
        self.$emit("showError", message, constants.ERROR_BUTTON_KIND_LOGIN);
      });
    },
    /**
     * key-value設定APIを実行
     *
     * @return {Promise} resolve:処理成功(true)/処理失敗(false), reject:アクセスキー無効メッセージ
     */
    doSetKeyValue: function(datajson) {
      var self = this;
      // key-value設定API
      return new Promise(function(resolve, reject) {
        self.setKeyValue(self.$parent.productInfo.code, datajson).then(function(response) {
          switch (response.result_code) {
            case "OK":
              resolve(true);
              break;
            case "INFO_INVALID_ACCESSKEY":
              var message = response.result_code;
              reject(message);
              break;
            default:
              resolve(false);
              break;
          }
        }).catch(function(err) {
          resolve(false);
        });
      });
    },
    /**
     * key-value設定APIパラメータ取得
     *
     * @param {String} key キー名
     * @param {String} value 設定値
     * @return {Object} key-valueオブジェクト
     */
    getApiParamKeyValue: function(key, value) {
      var result = {};
      result[key] = value;
      return result;
    },
    /**
     * ヒントテキストを取得
     * @param string modeGroup  Runmodeグループ
     * @param string sreUse 音声認識利用フラグ
     */
    setHintText: function(modeGroup, sreUse) {
      this.hintText = this.getHelpDialogHosokuText(modeGroup, sreUse);
    },
    /**
     * audioCompanionのクエリパラメータを取得する（lang)
     *
     * @param {String} language 言語コード
     * @return {String} クエリパラメータに設定する値
     */
    getQueryParamLang: function(language) {
      switch (language) {
        case constants.LANGUAGE_CODE_ENUS:
          return "ENG";
        case constants.LANGUAGE_CODE_ENGB:
          return "EBR";
        case constants.LANGUAGE_CODE_ZHCV:
          return "CHI";
        case constants.LANGUAGE_CODE_DEDE:
          return "DEU";
        case constants.LANGUAGE_CODE_FRFR:
          return "FRA";
        case constants.LANGUAGE_CODE_ITIT:
          return "ITA";
        case constants.LANGUAGE_CODE_VIVN:
          return "VIE";
        case constants.LANGUAGE_CODE_KOKR:
          return "KOR";
        case constants.LANGUAGE_CODE_ESES:
          return "ESC";
        case constants.LANGUAGE_CODE_ES419:
          return "ESP";
        case constants.LANGUAGE_CODE_AR:
          return "ARA";
        case constants.LANGUAGE_CODE_RURU:
          return "RUS";
        case constants.LANGUAGE_CODE_HIIN:
          return "HIN";
        case constants.LANGUAGE_CODE_TLPH:
          return "TGL";
        case constants.LANGUAGE_CODE_TRTR:
          return "TUR";
        case constants.LANGUAGE_CODE_SVSE:
          return "SVE";
        case constants.LANGUAGE_CODE_JAJP:
          return "JPN";
        case constants.LANGUAGE_CODE_PLPL:
          return "POL";
        case constants.LANGUAGE_CODE_PTBR:
          return "POR";
        case constants.LANGUAGE_CODE_HEIL:
          return "HEB";
        case constants.LANGUAGE_CODE_ELGR:
          return "GRK";
        case constants.LANGUAGE_CODE_NLNL:
          return "NED";
        case constants.LANGUAGE_CODE_GAIE:
          return "GLE";
        case constants.LANGUAGE_CODE_FAIR:
          return "FAR";
        default:
          break;
      }
      return "";
    },
    /**
     * 辞書画面を表示
     */
    goDictionary: function() {
      this.log("Toolbar start goDictionary")

      if(this.isEnvironmentPc()) {
        var url = process.env.LIBRARY_URL + "dictionary";
        window.open(url, '_blank', "width=980,height=800,resizable=yes,scrollbars=yes");
      } else {
        try {
          window.Phone.ShowDictionary("");
        } catch(e) {
          this.log("goDictionary err: " + e.message);

          var url = process.env.LIBRARY_URL + "?dictionary=true";
          window.location.replace(url);
        }
      }
    },
    /**
     * 単語リストを表示
     */
    goDictionaryWordList: function() {
      this.log("Toolbar start goDictionaryWordList")

      // 単語一覧取得
      var levelJson = this.getLevelJson(this.jsonData, this.levelNo);
      var unitJson = this.getUnitJson(levelJson, this.unitNo);
      var pathstep = unitJson.lessons[this.lessonIndex].paths[this.pathIndex].pathsteps[this.pathstepIndex];
      var wordList = this.getDictionaryWordList(pathstep);

      // 単語リストの表示
      try {
        window.Phone.ShowDictionaryWordList(wordList);
        // GoogleAnalyticsイベントヒット送信
        rosettaGA.sendEvent(
          constants.GA_EVENT.GATEGORY.WORD_LIST,
          constants.GA_EVENT.ACTION.CLICK,
          constants.GA_EVENT.LABEL.DICTIONARY,
          [this.productInfo.code]
        );
      } catch(e) {
        this.log("goDictionaryWordList err: " + e.message);
      }
    }
  },
  watch: {
    currentView: function(newCurrentView) {
      this.log("Toolbar watch currentView: " + newCurrentView);

      if (this.currentView === VIEW_NAME_HOME) {
        this.isCurrentViewHome = true;

        this.unitTitle = "";
        this.pathTitle = "";
        this.pathstepLength = 0;
        this.note = "";

        this.$store.dispatch('setShowDisplayMode', false);
      } else {
        this.isCurrentViewHome = false;
        this.setDataForRunmode();
      }
    },
    sreUse: function(newSreUse) {
      // sreUse変更
      this.setHintText(this.modeGroup, newSreUse);
    },
    modeGroup: function(newModeGroup) {
      // Runmodeグループ変更
      this.setHintText(newModeGroup, this.sreUse);
    },
    showAllAnswer: function(newShowAllAnswer) {
      this.isAllAnswerVisible = newShowAllAnswer;
    }
  },
  created: function() {
    this.audioCompanionURL = "https://www.rosettastone.com/AudioCompanion/?locale=" + constants.LANGUAGE_CODE_JAJP + "&lang=" + this.getQueryParamLang(this.productInfo.language);
    this.tourURL = "http://rd.snxt.jp/";
    if (!this.isEnvironmentPc()) {
      // スマホの場合
      this.tourURL += "40881";

      // 辞書メニュー表示を確認
      if(this.isAndroid()) {
        if(this.isCarrier()) {
          this.showDictionary = false;

          // au版Androidアプリでプレミアム会員対応版か確認
          if(this.isAu()) {
            if(window.Phone.GetVersionCode() >= 13) {
              this.isAuPremiumAppVer = true;
            }
          }
        }
      }
    } else {
      // PCの場合
      this.tourURL += "24686";
    }

    if(this.showDictionary) {
      // 英語の場合のみ辞書メニューを表示
      switch (this.productInfo.language) {
        case constants.LANGUAGE_CODE_ENUS:
        case constants.LANGUAGE_CODE_ENGB:
          break;
        default:
          this.showDictionary = false;
          break;
      }
    }
  },
  updated: function() {
    this.log("Toolbar start updated");

    if (this.currentView === VIEW_NAME_RUNMODE) {
      this.setDataForRunmode();
    }

    // ヒントエリア表示
    if (this.currentView === VIEW_NAME_RUNMODE) {
      // PC、Runmode画面の時表示
      this.showHintArea = true;
    } else {
      this.showHintArea = false;
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/style/header";
</style>



// WEBPACK FOOTER //
// Toolbar.vue?fc37e0cc